<template>
  <div>
    <b-form-textarea
      v-model="deliveryNotes"
      placeholder="Enter delivery instructions..."
      rows="3"
      max-rows="6"
    ></b-form-textarea>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import _ from 'lodash';

export default {
    name: "shopify-delivery-notes",
    created: function() {
        this.debouncedUpdateDeliveryNotes = _.debounce(this.updateDeliveryNotes, 1000)
    },
    computed: {
        ...mapState({
            basket: state => state.shopify.checkout,
        }),
        deliveryNotes: {
            get() {
                if(this.basket){
                    const notes = this.basket.customAttributes.find((v)=>{
                        return v.key == 'delivery_instructions';
                    })
                    return notes ? notes.value : '';
                }
                return '';
            },
            set(value) {
                this.notes = value;
                this.debouncedUpdateDeliveryNotes()
            }
        }
    },
    methods: {
        ...mapActions("shopify", ["updateCartAttribute"]),
        updateDeliveryNotes: function() {
            this.updateCartAttribute({
                key: 'delivery_instructions',
                value: this.notes
            }).then(v=>{
                console.log(v);
            });
        }
    }
}
</script>
